import React, {useContext} from 'react';
import TableComponent from '../TableComponent'
import { UsersContext } from '../../../context/users-context';
import { DetTunersContext } from '../../../context/dettuners-context';
import {AdminRole, DetTunerAdminRole} from '../../../model/constants'
import * as DetTunerWorker from '../../../workers/detTunerWorker'
import { Checkbox } from '@material-ui/core';

export default function TunerTable(props) {
  console.log("render TunerTable");

  const [usersState] = useContext(UsersContext);
  const [detTunersState, detTunersDispatch] = useContext(DetTunersContext);

  const [error, setError] = React.useState("");

  const isAdmin = usersState.currentUser?.Role === AdminRole;
  const isTunerAdmin = isAdmin || usersState.currentUser?.Role === DetTunerAdminRole;
  
  const columns = [
    { field: 'TunerId', title: 'Id', minWidth: 170, sorting: true, editable: 'onAdd', validate: (rowData) => !!rowData.TunerId },
    { field: 'IsCalibrationEnabled', title: 'Активность калибровки', type: 'boolean', sorting: false, render: isTunerAdmin ? (rowData) =>  onCellEdit("IsCalibrationEnabled", rowData) : undefined },
    { field: 'IsBoardsSettingEnabled', title: 'Активность настройки плат', type: 'boolean', sorting: false, render: isTunerAdmin ? (rowData) =>  onCellEdit("IsBoardsSettingEnabled", rowData) : undefined },
    { field: 'IsSearchDefectsEnabled', title: 'Активность поиска дефектов', type: 'boolean', sorting: false, render: isTunerAdmin ? (rowData) =>  onCellEdit("IsSearchDefectsEnabled", rowData) : undefined },
    { field: 'RegistrationDate', title: 'Дата регистрации', sorting: true, editable: 'never', type: 'datetime', dateSetting: { locale: navigator.language }, initialEditValue: (new Date()).toJSON() },
    { field: 'Comment', title: 'Комментарий', sorting: false, minWidth: 200 },
  ];

  const showError = (msg) => {
    setError(msg);
  }

  const onAdd = async (newData) => {
    const data = await DetTunerWorker.AddTuner(usersState.token, newData);
    if (data === undefined)
      return;
    if (data.error)
      showError(data.error);
  };
  
  const onEdit = async (newData) => {
    const data = await DetTunerWorker.UpdateTuner(usersState.token, newData);
    if (data === undefined)
      return;
    if (data.error)
      showError(data.error);
    else
      detTunersDispatch({type:'UPDATETUNER', payload: data});
  };
  
  const onDelete = async (oldData) => {
    const res = await DetTunerWorker.DeleteTuner(usersState.token, oldData.TunerId);
  };

  const onCellEdit = (field, rowData) => {
    return (
      <Checkbox 
        checked={rowData[field]}
        onChange={async (ev) => {
          const newRow = {...rowData };
          newRow[field] = ev.target.checked;
          await DetTunerWorker.UpdateTuner(usersState.token, newRow);
        }}
      />)
  }

  return (
    <TableComponent
      columns={columns}
      data={props.data}
      canEdit={isTunerAdmin}
      onRowAdd={onAdd}
      onRowUpdate={onEdit}
      onRowDelete={onDelete}
      errorMsg={error}
     />
  );
}